export enum bookingNavigationItems {
    purchaseList = 'purchase-list',
    reservation = 'reserved',
}
